import { Stack } from "@mui/material";
import Text from "src/components/Displays/Text";
import { openInNewTab } from "src/helpers/openInNewTab";
import { enphaseAuth } from "src/api/onboardingClients";
import ContentCard from "src/components/Shared/ContentCard";
import PrimaryButton from "src/components/Shared/PrimaryButton";
import HorizontalLinearProgressBar from "src/components/ProgressBar/HorizontalLinearProgressBar";

const System = () => {
  const handleEnphaseOnboarding = async () => {
    try {
      const response = await enphaseAuth();
      openInNewTab(response.targetUrl);
    } catch (e) {
      alert(
        "An error occurred while trying to onboard with Enphase. Please try again later."
      );
    }
  };

  return (
    <Stack alignItems={"center"} mt={50} p={5}>
      <Stack
        sx={(theme) => ({
          padding: theme.spacing(3),
          width: { xs: "100%", sm: "500px" },
          mb: theme.spacing(1),
        })}
      >
        <Text
          text="Onboard your system"
          sx={(theme) => ({
            color: "#DDB1FF",
            fontWeight: "500",
            mb: theme.spacing(3),
          })}
        />
        <HorizontalLinearProgressBar variant="determinate" value={50} />
      </Stack>

      <ContentCard sx={{ width: { xs: "100%", sm: "500px" } }}>
        <Stack gap={5}>
          <Text
            text={`Choose your system`}
            sx={(theme) => ({
              fontSize: "22px",
              lineHeight: "26px",
            })}
          />
          <Stack gap={3}>
            <PrimaryButton text={"enphase"} onClick={handleEnphaseOnboarding} />
            <PrimaryButton text={"sungrow"} />
          </Stack>
        </Stack>
      </ContentCard>
    </Stack>
  );
};

export default System;
